import { BASE_URL } from '../utils/constant';
import { localStore } from '../App';

class NavigationWarningsService 
{


  async fetchWarnings(): Promise<any> 
  {
    const remoteWarnings = await this.fetchRemoteWarnings();
    if (remoteWarnings) 
    {
      return remoteWarnings;
    }
    return this.fetchWarningsFromStorage();
  }


  async fetchWarningsFromStorage(): Promise<any> 
  {
    try 
    {
      const advice = await localStore.get("adviceList");
      if (advice != null) 
      {
        console.log('Informazioni sugli avvisi di cauta navigazione presenti in memoria.');
        return advice;
      }

      console.log('Non sono presenti informazioni sugli avvisi di cauta navigazione in memoria - riavviare l\'app e  riprovare');
      return null;
    }
    catch (error) 
    {
      console.log('Problema nella ricezione dei dati sugli avvisi di cauta navigazione - riavviare l\'app e riprovare ', error);
      throw error;
    }
  }


  
  async fetchRemoteWarnings(): Promise<[any] | null> 
  {
    console.log('fetchRemoteWarnings:: cerco avvisi di cauta navigazione sul server');
    return new Promise((resolve, reject) => {
      // const url = `${BASE_URL}/poServer.php?act=999&h=gkzLoFk0MN58TGqCJj`; // dev pourposes
      const url = `${BASE_URL}/poServer.php?act=16&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => 
          {
            console.log('Informazioni sugli avvisi di cauta navigazione scaricarte dal server.');
            localStore.set('adviceList', result.content);
            resolve(result.content);
          },
          (error) => {
            console.log('Problema nella ricezione dei dati sugli avvisi di cauta navigazione - controlliamo se ce ne sono in memoria ', error);
            resolve(null);
          }
        );
    });
  }

  /** Always hits the server (e.g. after a push about a new danger zone). Falls back to storage on failure. */
  async refreshWarningsFromServer(): Promise<any> {
    const remote = await this.fetchRemoteWarnings();
    if (remote != null) {
      return remote;
    }
    const cached = await this.fetchWarningsFromStorage();
    return cached != null ? cached : [];
  }
}

export default NavigationWarningsService; 